import { render } from "./FaceLayout.vue?vue&type=template&id=c3caa454&scoped=true"
import script from "./FaceLayout.vue?vue&type=script&lang=js"
export * from "./FaceLayout.vue?vue&type=script&lang=js"

import "@/assets/css/idcheck/face/style.css?vue&type=style&index=0&id=c3caa454&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3caa454"]])

export default __exports__